/*

MeganeTemplate

Version: 4.1.0
Website: http://megane-template.com/
License: Dentsu Isobar All Rights Reserved.

*/

export default class jTabac {

    constructor(selector, option) {

        this.selector = selector;

        //option
        if(option == null) option = {};
        this.fadeSpeed = option.fadeSpeed ? option.fadeSpeed : 0;
        this.slideSpeed = option.fadeSpeed ? option.fadeSpeed : 0;
        this.tbbtnElm = option.tbbtnElm ? option.tbbtnElm : ".j-tabac_tab_btn";
        this.acbtnElm = option.acbtnElm ? option.acbtnElm : ".j-tabac_ac_btn";
        this.detailElm = option.detailElm ? option.detailElm : ".j-tabac_detail";

        this.OpenEnd = function(){};

        this.Init();

    }


    /**
    **
    ** Init
    **
    **/
    Init() {
       
        const that = this;
        for (var i = 0; i < $(that.selector).find(that.tbbtnElm).length; i++) {
            var myhtml = $(that.selector).find(that.tbbtnElm).eq(i).html();
            
            $(that.selector).find(that.detailElm).eq(i).before("<div class='" + that.acbtnElm.replace(".","") + "'>" + myhtml + "</div>");
            
        }
    
        
        $(this.selector).each(function(){

            const $detail = $(this).find(that.detailElm);
            const $tbbtn = $(this).find(that.tbbtnElm);
            const $acbtn = $(this).find(that.acbtnElm);

            if( $detail.hasClass("active") ) {

                $detail.not(".active").hide();

            } else {

                $detail.hide();
                $detail.eq(0).addClass("active").show();
                $tbbtn.eq(0).addClass("active");
                $acbtn.eq(0).addClass("active");

            }

            $(this).on("click", that.tbbtnElm, function(e){

                e.preventDefault();

                that.target = this;
                that.Open(this);

            });
            
            $(this).on("click", that.acbtnElm, function(e){
                e.preventDefault();
                that.target = this;
                that.Accodion(this);
            });
        });

    }


    /**
    **
    ** Open
    **
    **/
    Open(elm) {

        const target = $(elm)[0] ? $(elm)[0] : this.target;
        const index = $(elm).parents(this.selector).find(this.tbbtnElm).index(target);

        const that = this;

        $(elm).parents(this.selector).find(this.tbbtnElm + ", " + this.detailElm).removeClass("active");
        $(elm).addClass("active");

        $(elm).parents(this.selector).find(this.detailElm).hide()
        .eq(index).fadeIn(this.fadeSpeed,function(){

            that.OpenEnd();

        }).addClass("active");

    }

    Accodion(elm) {
        
        const target = $(elm)[0] ? $(elm)[0] : this.target;
        const index = $(elm).parents(this.selector).find(this.acbtnElm).index(target);
        
        const that = this;

        $(elm).parents(this.selector).find(this.tbbtnElm + ", " + this.acbtnElm + ", " + this.detailElm).removeClass("active");
        $(elm).addClass("active");
        $(that.selector).find(that.tbbtnElm).eq(index).addClass("active");

        $(that.selector).find(that.detailElm).slideUp(this.slideSpeed,function(){
        }).removeClass("active");
        
        $(elm).next(that.detailElm).slideDown(this.slideSpeed,function(){
        }).addClass("active");

    }

}
